export const printHtmlInHiddenFrame = (html, cleanupDelay = 10000) => {
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.left = '-10000px';
  iframe.style.top = '0';
  iframe.style.width = '210mm';
  iframe.style.height = '297mm';
  iframe.style.border = '0';
  iframe.setAttribute('aria-hidden', 'true');
  document.body.appendChild(iframe);

  let cleanupTimer;
  const cleanup = () => {
    clearTimeout(cleanupTimer);
    iframe.remove();
  };
  iframe.contentWindow.addEventListener('afterprint', cleanup, { once: true });
  // Keep the document alive while the user reviews the native print dialog.
  // A longer fallback handles browsers that do not emit afterprint.
  cleanupTimer = setTimeout(cleanup, Math.max(cleanupDelay, 300000));

  const doc = iframe.contentDocument || iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();

};

export const printHtmlInWindow = html => {
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    printHtmlInHiddenFrame(html);
    return;
  }
  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
};
